import React, { useState } from 'react'
import Modal from '../../Modal'
import { Formik } from 'formik'
import { useStore } from '../../../stores/store';
import * as Yup from 'yup';
import Question from '../../Question';
import { ExportRequestDto } from '../../../models/Export/ExportRequestDto';
import { observer } from 'mobx-react-lite';

const ExportForm = observer(() => {
    const { activityStore } = useStore();
    const { exportFormIsVisible, exportFormValues, exportActivities, formSubmissionIsLoading, chosenDateForActivities, setExportFormVisible } = activityStore;

    const [sendByEmail, setSendByEmail] = useState(false);

    if (!exportFormIsVisible) return null;

    const initialValues : ExportRequestDto = exportFormValues ?? {
        recipientEmail : "",
        monthYear : chosenDateForActivities.toISOString()
    };

    const handleSubmit = async (values : ExportRequestDto) => {
        await exportActivities(values);
    }

    const validationSchema = Yup.object().shape({
        recipientEmail: Yup.string()
        .email("Invalid email address")
        .when([], {
            is: () => sendByEmail,
            then: (schema) => schema.required("Recipient email is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

    return (
        <Modal>
            <h2 className="text-2xl font-bold mb-4 text-center">Export Activities</h2>
            <p className="mb-2 text-center">Exporting activities for {new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(chosenDateForActivities)}</p>
            <p className="mb-4 text-center">Tick the checkbox to send by email, or hit export and download your activities to your device.</p>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
                validationSchema={validationSchema}>
            {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isValid }) => (
                <form onSubmit={handleSubmit}>
                    <div className="mb-4 mx-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="sendByEmail">
                            <div className="flex items-center">
                                <input 
                                    type="checkbox" 
                                    id="sendByEmail" 
                                    checked={sendByEmail} 
                                    onChange={() => setSendByEmail(!sendByEmail)} 
                                    onBlur={handleBlur} 
                                    className="h-5 w-5 accent-blue-500 cursor-pointer" 
                                />
                                <span className="ml-3">Send by email</span>
                            </div>
                        </label>
                    </div>
                    {sendByEmail && (
                        <Question 
                            type="text" 
                            id="recipientEmail" 
                            title="Recipient Email" 
                            error={errors.recipientEmail} 
                            touched={touched.recipientEmail} 
                            placeHolder='bob@dylan.com' 
                            value={values.recipientEmail} 
                            handleChangeEvent={handleChange} 
                            handleBlurEvent={handleBlur} 
                        />
                    )}

                    <div className="flex flex-col items-center gap-2">
                        <input 
                            id='submitButton' 
                            className='bg-green-500 hover:bg-green-700 transition-colors text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline' 
                            type="submit" 
                            disabled={formSubmissionIsLoading} 
                            value="Export" 
                        />
                        <button 
                            className='bg-blue-500 hover:bg-blue-700 transition-colors text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline' 
                            onClick={() => {
                                setSendByEmail(false)
                                setExportFormVisible(false)
                            }}
                        >Cancel</button>
                    </div>
                </form>
            )}

            </Formik>
        </Modal>
    )
})

export default ExportForm;